import React from "react";
import styled from "styled-components";
import UnderlinedHeader from "../../molecules/UnderlinedHeader/UnderlinedHeader";
import { Container } from "react-bootstrap";
import { PRIMARY } from "../../../vars/vars";

const Returns = () => (
  <Wrapper>
    <Container>
      <UnderlinedHeader text={"30 dni na zwrot"} bolder />
      <p>
        Jeśli nie jesteś zadowolony z zakupu możesz zwrócić towar. W tym celu
        prosimy postępuj zgodnie z poniższymi instrukcjami.
      </p>
      <p>
        Zwroty są akceptowane w ciągu 30 dni od daty zakupu (daty wystawienia
        faktury).
      </p>
      <p>
        Wszystkie zwracane towary muszą być się w stanie nienaruszonym,
        oryginalnie zapakowane (bez oznak otwarcia) i zawierać wszystkie
        oryginalne etykiety i opakowanie producenta.
      </p>
      <p>
        Jeżeli jakiekolwiek części zostały zakupione jako zestaw, nie ma
        możliwości zwrotu jego poszczególnych elementów. W takich przypadkach
        możliwy jest zwrot tylko całego zestawu zawierającego wszystkie
        elementy. Zwroty pojedynczych elementów zestawu zostaną odrzucone i
        odesłane na koszt klienta.
      </p>
      <p>
        Przed zwrotem jakichkolwiek produktów najpierw proszę skontaktuj się z
        nami:{" "}
        <StyledLink href={"mailto:support@pedders.pl"}>
          support@pedders.pl
        </StyledLink>
      </p>
      <p>
        Ważne! Upewnij się, że do zwracanych towarów dołączyłeś wypełniony
        formularz zwrotu (
        <StyledLink
          target={"_blank"}
          href={"http://dba4x4.home.pl/warranty/return/"}
          rel={"noopener noreferrer nofollow"}
        >
          możesz go pobrać tutaj
        </StyledLink>
        ) wraz z kopią faktury, a zwrot został do nas odesłany nie później niż w
        ciągu 30 dni od dnia zakupu (daty wystawienia faktury).
      </p>
      <p>
        Wszelkie zwroty towarów nie zatwierdzone przez nas będą odrzucane.
        Koszty zwrotu takiego produktu oraz ponownej wysyłki do Ciebie będą po
        Twojej stronie. Dlatego przed podjęciem jakichkolwiek działań proszę
        skontaktuj się z nami.
      </p>
      <p>
        Wysyłając zwracane produkty, jesteś odpowiedzialny za prawidłowe
        zapakowanie i wysłanie, tak aby nie uległy one uszkodzeniu lub
        zagubieniu podczas transportu.
      </p>
      <p>
        Chętnie zwrócimy wartość zwróconych nam nieuszkodzonych i nieużywanych
        produktów bez opłaty manipulacyjnej w ciągu 30 dni od daty sprzedaży.
      </p>
    </Container>
  </Wrapper>
);

export default Returns;

const Wrapper = styled.section`
  padding-top: 92px;
  font-size: 14px;
  font-family: "Open Sans", sans-serif;
  color: #666666;
`;

const StyledLink = styled.a`
  font-weight: 600;
  color: ${PRIMARY};
`;
